import type { MouseEvent } from 'react';
import type { TFunction } from 'i18next';
import UserAvatar from '../../components/UserAvatar';
import type { OwnerInfo } from '../../models/mapObject';
import { openTelegramProfile } from '../../utils/telegram/openTelegramProfile';


export interface OwnerSectionProps {
  owner: OwnerInfo;
  handleShowTooltip: (e: MouseEvent) => void;
  getDisplayFirstName: () => string;
  t: TFunction;
}

export default function OwnerSection({
  owner,
  handleShowTooltip,
  getDisplayFirstName,
  t,
}: OwnerSectionProps) {
  const handleOwnerClick = (e: MouseEvent) => {
    handleShowTooltip(e);
    openTelegramProfile(owner.username);
  };

  return (
    <div className="mb-xl flex w-full items-center justify-between">
      <div className="flex flex-1 items-start gap-[14px]">
        {/* Avatar */}
        <UserAvatar
          user={owner}
          onClick={handleOwnerClick}
          size={58}
        />

        {/* Name and level */}
        <div className="flex flex-1 flex-col gap-0">
          <div
            onClick={handleOwnerClick}
            className="cursor-pointer [font-family:Lato,sans-serif] text-[16px] leading-[29px] font-bold tracking-[-0.747px] text-white"
          >
            {getDisplayFirstName()}
          </div>
          <div
            onClick={handleOwnerClick}
            className="cursor-pointer [font-family:Lato,sans-serif] text-[14px] leading-[29px] font-light tracking-[-0.747px] text-white"
          >
            lvl: {owner.level}
          </div>
        </div>
      </div>
      
      {/* Owner badge */}
      <div className="flex items-center justify-center rounded-[5px] border border-brand bg-deep-blue px-lg py-0">
        <div className="[font-family:Lato,sans-serif] text-[14px] leading-[29px] font-light tracking-[-0.747px] text-white italic">
          {t("owner")}
        </div>
      </div>
    </div>
  );
}
